import { ReactComponent as CloseIcon } from '../../assets/icons/x.svg';
import './dialog.scss';

const Dialog = ({
  title,
  isOpen,
  onClose,
  showCloseButton = true,
  children,
  className
}) => {
  return (
    <div className={`dialog ${isOpen ? 'open' : ''} ${className}`}>
      <div className='dialog__backdrop' onClick={onClose} />
      {isOpen && (
        <div className='dialog__content'>
          <div className='dialog__header'>
            <h2 className='dialog__title'>{title}</h2>
            {showCloseButton && (
              <button className='dialog__close-button' onClick={onClose}>
                <CloseIcon />
              </button>
            )}
          </div>
          <div className='dialog__description'>{children}</div>
        </div>
      )}
    </div>
  );
};

export default Dialog;
